var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"puzzleWordMark",class:{
  "puzzleWordMark--selection": !_vm.answer,
  "puzzleWordMark--answer": _vm.answer
},style:(_vm.markStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }